import * as React from 'react'
import { ReactElement } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useAxios from '../../../../hooks/useAxios'
import useAttributes, { AttributeContextType, AttributeViewType, EntityAttributeType } from '../../../../hooks/useAttributes'
import { CreateDto } from '../../../../config/filePartyConfig'
import { AddPartyProps, PartyStatus } from '../../../../components/Form/Party/PartyForm'
import PartyForm from '../../../../components/Form/Party/PartyForm'
import { applyFolderIntent } from '../../../components/Input/folderPath'
import { getNaturalPersonValidationSchema, NaturalPersonMutationDto } from '../../../config/partyMutationConfig'
import NaturalPersonFormBody from './NaturalPersonFormBody'
import UnsavedChangesGuard from '../../../components/Form/UnsavedChangesGuard'
import { partyGoBack } from './partyGoBack'

/** v9 add screen for a natural person (HAM-3911), from the dossier or the general party overview. */
export default function AddNaturalPersonPage(): ReactElement {
    const axios = useAxios()
    const history = useHistory()
    const location = useLocation()
    const { t: translate } = useTranslation()
    const { fileId } = useParams<{ fileId?: string }>()

    const attributes = useAttributes(AttributeViewType.Input, [AttributeContextType.NaturalPerson], undefined, EntityAttributeType.Party)

    const initialValues = {
        name: { initials: '', first: '', given: '', insertion: null, last: '' },
        addressCountry: 'NL',
        status: PartyStatus.Active,
    } as NaturalPersonMutationDto

    attributes.applyDefaultValues(initialValues)

    const goBack = partyGoBack(history)

    return (
        <PartyForm<NaturalPersonMutationDto>
            formikProps={{
                initialValues,
                validationSchema: getNaturalPersonValidationSchema(translate, attributes.activeAttributeDefinitions),
            }}
            onSubmit={async (party: NaturalPersonMutationDto) => {
                await applyFolderIntent(axios, party)
                return await axios.post<string>('/party/natural', {
                    ...party,
                    pivot: fileId ? ({ fileId, ...((location.state as AddPartyProps) || {}) } as CreateDto) : undefined,
                })
            }}
            goBack={goBack}
            attributes={attributes}
        >
            <NaturalPersonFormBody goBack={goBack} attributes={attributes} />
            <UnsavedChangesGuard />
        </PartyForm>
    )
}
